import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AutocompleteDataSourceFn, createDtoProperties, MgAutocompleteComponent, MgAutocompleteData } from '@mango/core';
import { CudBatchService } from '@mango/core';
import { Instrument } from 'src/app/core/dto/instrument';
import { Project } from 'src/app/core/dto/project';
import { Projectregel } from 'src/app/core/dto/projectregel';
import { Relatie } from 'src/app/core/dto/relatie';
import { InstrumentService } from 'src/app/core/service/instrument.service';
import { ProjectregelService } from 'src/app/core/service/projectregel.service';
import { WithoutValidationMessage } from 'src/app/core/utils/string';
import { InstrumentComponent } from '../../instrument/instrument/instrument.component';

export interface InstrumentBarcodeDialogData {
    project: Project;
    relatie: Relatie;
}

@Component({
    selector: 'c-i-j-borculo-instrumentbarcode',
    templateUrl: './instrumentbarcode.component.html',
    styleUrls: ['./instrumentbarcode.component.css']
})
export class InstrumentBarcodeComponent {
    
    @ViewChild('instrumentAutocomplete') instrumentAutocomplete: MgAutocompleteComponent;
    @ViewChild('savebutton') savebutton: HTMLButtonElement;
    @ViewChild('barcode') barcodefield: Input;

    InstrumentFormGroup: FormGroup;
	getInstrumentDataSource: AutocompleteDataSourceFn<Instrument> = MgAutocompleteData.empty();
    isDisabled: boolean = true;
    barcodenotfound: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: InstrumentBarcodeDialogData,
        private dialogRef: MatDialogRef<InstrumentBarcodeComponent>,
        private service: ProjectregelService,
        private instrumentService: InstrumentService,
        private snackBar: MatSnackBar,
        private fb: FormBuilder)        
    {


    }    

    ngOnInit() {
    
        this.InstrumentFormGroup = this.fb.group({
			instrument: this.fb.control(null, null),
            barcode: this.fb.control(null, null),
		});

        this.getInstrumentDataSource = MgAutocompleteData.complex<Instrument>(this.instrumentService, this.instrumentService.getRelatieFilterNoBarcode(this.data.relatie)).text('soort', 'merk', 'type', 'nr_Barcode', 'nr_Fabriek', 'nr_Instrument', 'groep')
            .createNewDto({componentType:InstrumentComponent, defaults:{relatie:this.data.relatie, isVervallen:false}}).datasource();            			
    
    }

    instrumentDisplayFn(instrument: Instrument) {
        return `${(instrument.soort != null ? instrument.soort : "") } - ${(instrument.merk != null ? instrument.merk : "") } - ${(instrument.type != null ? instrument.type : "") } ${(instrument.nr_Fabriek != null ? "[ " + instrument.nr_Fabriek + "]": "") }`;
	}   
            
    getBarcode(barcode) {
        
        // Hier moeten we dan het instrument aanmaken!
        this.service.addinstrument(barcode, this.data.project).toPromise().then((value) => {
            if (value.message != "" && value.message != null){
                this.snackBar.open("Instrument toegevoegd! " + value.message, 'ok', { duration: undefined });      
            } else {
                this.snackBar.open("Instrument toegevoegd!", 'ok', { duration: 4000 });            
            }

            this.dialogRef.close({data:'ok'});
        }).catch(value => {
           
            if (value.error.message == "Validation failed. Geen instrument gevonden met deze barcode."){
                // Barcode bestaat niet -> scherm open houden en autocomplete tonen
				setTimeout(() => {
                    this.instrumentAutocomplete.setDisabledState(false);
                    this.isDisabled=false;
                    this.instrumentAutocomplete.focusInput();
				});                
            }
            else {
                this.dialogRef.close({data:'exc'});
            }
            // Snackbar altijd tonen            
            this.snackBar.open(WithoutValidationMessage(value.error.message), 'ok', { duration: 6000 });
        });
    }

    SaveAndAddBarcode(){

        // Toevoegen Barcode aan Instrument
        let { instrument, barcode } = this.InstrumentFormGroup.value;
        
        // Via de autocomplete kun je een nieuwe toevoegen, dus overschrijf de barcode
        if (instrument?.nr_Barcode != null)
        {
            barcode = instrument?.nr_Barcode;
        }

        this.instrumentService.setBarcode(instrument.id, barcode).toPromise()
            .then((value) => {
                if (value.successful) {
                    this.getBarcode(barcode);                    
                }
            })
            .catch(err => {
                let error = err?.error?.message;
                console.error(err);
                this.snackBar.open(`Er is iets misgegaan. ${error}`, 'ok', { duration: 100000 });
            })
    

    }   

}
